import React from 'react';
import TrovaLogoMark from './TrovaLogoMark';

const TrovaBrand: React.FC = () => (
  <div className="login-brand">
    <TrovaLogoMark width={36} height={36} />
    <span className="login-brand-wordmark">Trova</span>
  </div>
);

export default TrovaBrand;
